<template>
  <div class="page">
    <img src="../../assets/images/acmedback.png" class="topimg" alt="" />
    <div class="totle">
      <div class="titletext">
        恭喜您完成申请!
      </div>
      <!-- <div class="titlebtn" @click="goToUpload()">
        <div class="iconout"><img src="../../assets/images/enterinicon.png" alt="" class="btnicon"></div>
        <div>请点击进入申请流程</div>
      </div> -->
      <div class="qrcode">
        <img src="../../assets/images/enterincode.png" class="okqrcode1" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "uploadInfo",
  data() {
    return {};
  },
  computed: {},
  created() {
    document.title = "加入ACMED";
  },
  beforeDestroy() { },
  methods: {
    goToUpload() {
      this.$router.push({ name: 'acmedUpload' })
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgb(247, 249, 253);
}

.totle {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
}

.maintitle {
  margin: auto;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 1rem;
}

.okqrcode {
  display: block;
  margin: auto;
  width: 70%;
  margin-top: 1rem;
}

.okqrcode1 {
  display: block;
  margin: auto;
  width: 55%;
  margin-top: 1rem;
}

.maininner {
  width: 73%;
  margin: auto;
  font-size: 20px;
}

.topimg {
  width: 100%;
  height: 100%;
  display: block;
}

.titletext {
  text-align: center;
  font-size: .6rem;
  font-weight: bold;
  color: rgb(32, 44, 87);
  margin-bottom: 2rem;
}

.titlebtn {
  width: 52%;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 50rem;
  padding: 0.1rem 0;
  justify-content: center;
  background-image: linear-gradient(to right, rgb(0, 70, 147), rgb(2, 158, 237));
  color: #fff;
  margin: 0.5rem auto;
}

.btnicon {
  display: block;
  width: 100%;
}

.iconout {
  width: 10%;
  padding-right: 0.2rem;
}
</style>